import { render, staticRenderFns } from "./WillResidentialPartnerYN.vue?vue&type=template&id=6952e34e"
import script from "./WillResidentialPartnerYN.vue?vue&type=script&lang=js"
export * from "./WillResidentialPartnerYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports